import SwiperCore, { Navigation, EffectFade } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import gsap from "gsap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronRight,
  faChevronLeft,
} from "@fortawesome/free-solid-svg-icons";
import { useContext, useEffect, useState } from "react";
import { WindowWidthContext } from "../App";

SwiperCore.use([Navigation, EffectFade]);

function Gallery() {
  const [index, setIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const windowWidth = useContext(WindowWidthContext);

  const arr = [0, 1, 2, 3];

  useEffect(() => {
    if (windowWidth > 1400) {
      setIsMobile(false);
    } else {
      setIsMobile(true);
    }
  }, [windowWidth]);

  useEffect(() => {
    if (index !== 1) {
      const tl = gsap.timeline();
      tl.set(".swiper-slide-active", {
        visibility: "visible",
      })
        .set(".swiper-slide-active .home__gallery__container__desc", {
          translateX: isMobile ? 0 : "-50%",
        })
        .from(`.swiper-slide-active .home__gallery__container__img-container`, {
          scale: (0.8, 0.8),
          duration: 0.8,
          opacity: 0,
        })
        .from(
          `.swiper-slide-active .home__gallery__container__desc`,
          !isMobile
            ? {
                scaleY: 0,
                transformOrigin: "top",
                opacity: 0,
                duration: 0.8,
              }
            : {}
        )
        .from(`.swiper-slide-active .home__gallery__container__desc h3`, {
          x: -15,
          opacity: 0,
          duration: 0.8,
          transformOrigin: "left",
        })
        .from(`.swiper-slide-active .home__gallery__container__desc p`, {
          y: -20,
          opacity: 0,
          duration: 0.8,
        })
        .from(
          ".home__gallery__pagination",
          index === 0 ? { opacity: 0, duration: 0.8 } : {}
        );
    } else {
      const tl = gsap.timeline();
      tl.set(".swiper-slide-active .home__gallery__container__desc", {
        translateX: isMobile ? 0 : "-50%",
      });
    }
  }, [isMobile, index]);

  return (
    <Swiper
      slidesPerView={1}
      navigation={{
        nextEl: ".home__gallery__pagination-next",
        prevEl: ".home__gallery__pagination-prev",
      }}
      loop={true}
      onSlideChange={(e) => {
        setIndex(e.activeIndex);
      }}
      className="home__gallery"
    >
      <div className="home__gallery__pagination-prev home__gallery__pagination">
        <FontAwesomeIcon className="icon" icon={faChevronLeft} />
        <FontAwesomeIcon className="icon" icon={faChevronLeft} />
        <span>Prev</span>
      </div>
      <div className="home__gallery__pagination-next home__gallery__pagination">
        <span>Next</span>
        <FontAwesomeIcon className="icon" icon={faChevronRight} />
        <FontAwesomeIcon className="icon" icon={faChevronRight} />
      </div>
      {arr.map((el) => (
        <SwiperSlide className="home__gallery__container" key={el}>
          <div className="home__gallery__container__img-container">
            <img src={`/images/gallery${el}.webp`} />
          </div>
          <div className="home__gallery__container__desc">
            <h3>braies lake</h3>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim
            </p>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}

export default Gallery;
